import React from "react";
import { LockIcon, ZapIcon, ShieldCheckIcon, MailIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
const assurances = [{
  icon: LockIcon,
  label: "Pago seguro",
  detail: "Stripe · PayPal · Mercado Pago"
}, {
  icon: ZapIcon,
  label: "Acceso en 5 minutos",
  detail: "Directo a tu correo"
}, {
  icon: ShieldCheckIcon,
  label: "Garantía 7 días",
  detail: "100% de devolución"
}, {
  icon: MailIcon,
  label: "Soporte en 24h",
  detail: "Te respondemos rápido"
}];
export function FinalCta() {
  return <section aria-labelledby="final" className="w-full bg-ink-soft py-16 text-cream lg:py-20" data-id="element-53" data-mp="1ed0h7o2xwp8w">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-54" data-mp="1t1wqtpknaabm">
        <h2 id="final" className="font-display text-3xl font-black sm:text-5xl" data-id="element-55" data-mp="1o3v50wvu3wwg">
          “El próximo mes puede ser diferente.”
        </h2>
        <p className="mt-6 font-display text-2xl font-bold" data-id="element-56" data-mp="224o13m1sb01o">
          <span className="text-cream/50 line-through decoration-2" data-id="element-57" data-mp="1x4tcxq9e8okb">$97</span>{" "}
          <span className="text-5xl font-black text-gold" data-id="element-58" data-mp="1x2p0gjxfih8f">$17</span>
        </p>
        <CtaButton className="mt-8" data-id="element-59" data-mp="n7fdpjpo0sax" />

        <ul className="mt-12 grid gap-6 border-t border-ink-line pt-10 text-left sm:grid-cols-2 lg:grid-cols-4" data-id="element-60" data-mp="s4filras3p0g">
          {assurances.map(({
          icon: Icon,
          label,
          detail
        }) => <li key={label} className="flex items-start gap-3" data-id="element-61" data-mp="x64xji14gmtt">
              <Icon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-62" data-mp="124g8xx72f5e5" />
              <div data-id="element-63" data-mp="163p14xmgiv7l">
                <p className="font-semibold" data-id="element-64" data-mp="1646unmhqivbt">{label}</p>
                <p className="text-sm text-cream/60" data-id="element-65" data-mp="1b31pjmsz8aca">{detail}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}